import React from 'react';
import autoBind from 'react-autobind';
import SmartModal from '@common/components/modals/smartModal';
import { Modal, Col, Row } from 'react-bootstrap';
import DataGrid from '@common/components/grid/dataGrid.component';
import DDados from '../address.ddados';
import DDadosItem from '@common/components/ddados/ddados.item';
import api from '@common/components/address/service/address.service';

class GenericLookupAddress extends React.Component {
  constructor(props) {
    super(props, DDados);
    let actions =
      props.onMultipleSelect || props.onlyView
        ? []
        : (actions = [
            {
              type: 'select',
              onClick: props.onSelect,
            },
          ]);

    const options = {
      recurso: props.recurso || (props.options ? props.options.recurso : undefined),
      applySearchOnLoad: props.applySearchOnLoad || (props.options ? props.options.applySearchOnLoad : undefined),
      isNotCheckable: props.onMultipleSelect ? false : true,
      noStorage: true,
    };

    const toolbar = {
      tools: {
        limpar: true,
      },
    };

    this.state = {
      config: {
        columns: props.columns,
        order: props.order,
        parameters: props.parameters,
        actions,
        options,
        toolbar,
      },
      configExterno: {
        columns: props.columnsExterno,
        order: props.order,
        parameters: props.parameters,
        actions,
        options,
        toolbar,
      },
      FiltrarEndereco: 1,
    };

    autoBind(this);
    this.refGrid = React.createRef();
  }

  onCheckItem() {
    if (!this.props.getAll) {
      const grid = this.refGrid.current;
      if (grid.getSelectedItens().length > 0) this.refButtonAssociar.disabled = false;
      else this.refButtonAssociar.disabled = true;
    }
  }

  onCheckAll() {
    if (!this.props.getAll) {
      const grid = this.refGrid.current;
      if (grid.getSelectedItens().length > 0) this.refButtonAssociar.disabled = false;
      else this.refButtonAssociar.disabled = true;
    }
  }

  get getService() {
    return this.state.FiltrarEndereco == 1 ? api.filterAddressCommonLookup : api.filterAddressLookup;
  }

  render() {
    const { Campos } = DDados;
    const { title, show, onClose, parameters, onlyView } = this.props;
    let { config, configExterno } = this.state;

    config.options.service = this.getService;

    return (
      <SmartModal
        show={show}
        onHide={onClose}
        size="lg"
        autoFocus={false}
        keyboard
        enforceFocus={false}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            <h3>{title}</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col lg={6}>
              <DDadosItem
                name="FiltrarEndereco"
                state={this.state}
                {...Campos.FiltrarEndereco}
                onChange={(FiltrarEndereco) => this.setState({ FiltrarEndereco })}
              />
            </Col>
          </Row>

          {this.state.FiltrarEndereco !== 1 ? (
            <DataGrid
              ref={this.refGrid}
              onCheckItem={this.onCheckItem}
              onCheckAll={this.onCheckAll}
              {...config}
              parameters={parameters}
            />
          ) : (
            <DataGrid
              ref={this.refGrid}
              onCheckItem={this.onCheckItem}
              onCheckAll={this.onCheckAll}
              {...configExterno}
              parameters={parameters}
            />
          )}
        </Modal.Body>

        <Modal.Footer>
          {!onlyView && (
            <button onClick={onClose} className="btn btn-cancel">
              <i className="fa fa-ban" /> Cancelar
            </button>
          )}

          {onlyView && (
            <button onClick={onClose} className="btn btn-cancel">
              <i className="fa fa-times" /> Fechar
            </button>
          )}
        </Modal.Footer>
      </SmartModal>
    );
  }
}

export default GenericLookupAddress;
